var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "SI_4L_stroke",
    cx: 21.2,
    cy: 21.2,
    r: 17.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_green",
    d: "M27.8 12.3l-8.6 10.5c-.5.6-1.5.7-2.1.1l-3.4-3.4c-.6-.6-1.5-.5-2 0l-3 3.3c-.5.5-.5 1.4 0 1.9l1.1 1.1L17 33c.6.6 1.5.5 2.1-.1l13.6-16.3c.5-.6.4-1.4-.1-1.9L29.8 12c-.5-.4-1.5-.4-2 .3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.fec5adf1a2a96471a52b5e6beb52d249.svg";
export { ForwardRef as ReactComponent };